module.exports = __webpack_public_path__ + "img/suit-03.0412b3c7.png";